import { render, staticRenderFns } from "./PrivacyPolice.vue?vue&type=template&id=44b8648a&"
import script from "./PrivacyPolice.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports